import { Injectable, Injector } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { microserviceUrls } from 'src/environments/environment';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable()
export class RequestOriginInterceptor implements HttpInterceptor {

    // pdv - URL´s de microservicios válidos para interceptar
    private readonly microUrls = microserviceUrls;

    constructor(private injector: Injector) {}

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const legacyBaseUrl = this.injector.get(AuthService).getLegacyBaseUrl();
        const isTargetingMicroservice =
            this.microUrls.some((url) => request.url.startsWith(url)) ||
            request.url.startsWith(legacyBaseUrl);

        if (!isTargetingMicroservice) {
            return next.handle(request);
        }

        const requestMod = request.clone({
            setHeaders: {
                'X-Request-Origin': 'pdv'
            },
        });

        return next.handle(requestMod);
    }
}
